import { useState } from 'react'

import { del } from '../../utils/api'
import { handleApiErrors } from '../../utils/apiErrors'
import { DeleteObservationHandler, Observation } from './types'

export const useDeleteObservation = () => {
  const [isDeleting, setDeleting] = useState(false)

  const deleteObservation: DeleteObservationHandler = ({
    observationId,
    onDeleted,
  }) => {
    setDeleting(true)
    del<Observation>(`/observations/${observationId}`)
      .then(() => {
        if (onDeleted) onDeleted()
      })
      .catch(handleApiErrors)
      .finally(() => setDeleting(false))
  }

  return { isDeleting, deleteObservation }
}
